import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Header from './components/Header';
import Footer from './components/Footer';
import Website from './components/Website';
import AboutUs from './components/AboutUs';
import Innovation from './components/Innovation';
import ContactUs from './components/ContactUs';
import ComingSoon from './components/ComingSoon';

function App() {
  return (
    <Router>
      <div className="App flex flex-col min-h-screen">
        <Header />
        <main className="flex-grow">
          <Routes>
            <Route path="/" element={<Website />} />
            <Route path="/about" element={<AboutUs />} />
            <Route path="/innovation" element={<Innovation />} />
            <Route path="/contact" element={<ContactUs />} />
            <Route path="/berry-club" element={<ComingSoon />} />
          </Routes>
        </main>
        {/* Only show footer on pages other than home */}
        <Routes>
          <Route path="/" element={null} />
          <Route path="*" element={<Footer />} />
        </Routes>
      </div>
    </Router>
  );
}

export default App;